import { createFileRoute } from "@tanstack/react-router";
import { ContractCompanyAnalysisPage } from "@/features/contracts/contract-company-analysis-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.szablony",
			location.pathname,
		);
	},
	component: ContractCompanyAnalysisPage,
});
